import axios from "axios";
import constants from "./../constants/Constants";
import { COOKIE, cookiesToDelete, deleteCookie, getCookie } from "./Cookie";
/**
 * @name fetchApi
 * @description will fetch the data based on params supplied
 * @param {string} param
 * @param {string} method
 * @param {object} variables
 */
/**
 * @name fetchStaffApi
 * @description will fetch the data based on params supplied
 * @param {string} param
 * @param {string} method
 * @param {object} variables
 */

// const getRedirectRoute = () => {
// 	if(getCookie(COOKIE.UserType) === "1")
// 		return frontendurls.AdminLogin
// 	return frontendurls.UserLogin
// }

export const fetchApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.ApiUrl}${param}`,
		data: variables,
		headers: {
				Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
	})
	.then((res) => {
			return res.data;
	})
	.catch((err) => {
		console.log("The Api error", err);
		if (err.response.data.message && err.response.data.status_code) {
			console.log(err.response.data);
		}
		let { status } = err.response;
		if (status === 401) {
			console.log("Error", err.response.data);
			if(err.response.data.error_message==="Invalid token"){
				cookiesToDelete.forEach((record) => deleteCookie(record, "/"));
				// let route = getRedirectRoute();
				window.location.href = constants.BaseUrl+"login";
			}
			if (err.response.data.message) {
				return err.response.data;
			} else if(err.response.data.error_message){
				return err.response.data;
			}else {
				return false;
			}
		}else if (status === 400) {
			if (err.response.data.message) {
				return err.response.data;
			}else if(err.response.data.error_message){
				return err.response.data;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
	export const fetchUserApi = (param = null, method = null, variables = null,isUser=false) =>
		axios({
			method: method,
			url: `${isUser?constants.UserApiURL:constants.ApiUrl}${param}`,
			data: variables,
			headers: {
					Authorization: `Bearer ${getCookie(COOKIE.Token)}`
			},
		})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			console.log("The Api error", err);
			if (err.response.data.message && err.response.data.status_code) {
				console.log(err.response.data);
			}
			let { status } = err.response;
			if (status === 401) {
				console.log("Error", err.response.data);
				if(err.response.data.error_message==="Invalid token"){
					cookiesToDelete.forEach((record) => deleteCookie(record, "/"));
					// let route = getRedirectRoute();
					window.location.href = constants.BaseUrl+"login";
				}
				if (err.response.data.message) {
						return err.response.data;
				} else if(err.response.data.error_message){
						return err.response.data;
				}else {
						return false;
				}
			} else if (status === 400) {
					if (err.response.data.message) {
						return err.response.data;
					}else if(err.response.data.error_message){
						return err.response.data;
					} else {
						return false;
					}
			} else {
					return false;
			}
			});
export const fetchAdminApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.AdminApiUrl}${param}`,
		data: variables,
		headers: {
				Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
	})
	.then((res) => {
		return res.data;
	})
	.catch((err) => {
		console.log("The Api error", err);
		if (err.response.data.message && err.response.data.status_code) {
			console.log(err.response.data);
		}
		let { status } = err.response;
		if (status === 401) {
			console.log("Error", err.response.data);
			if(err.response.data.error_message==="Invalid token"){
				cookiesToDelete.forEach((record) => deleteCookie(record, "/"));
				// let route = getRedirectRoute();
				window.location.href = constants.BaseUrl+"admin-login";
			}
			if (err.response.data.message) {
					return err.response.data;
			} else if(err.response.data.error_message){
					return err.response.data;
			}else {
					return false;
			}
		} else if (status === 400) {
				if (err.response.data.message) {
					return err.response.data;
				}else if(err.response.data.error_message){
					return err.response.data;
				} else {
					return false;
				}
		} else {
				return false;
		}
		});
export const fetchDownloadApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.ApiUrl}${param}`,
		data: variables,
		headers: {
				Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
		responseType: 'blob'
	})
	.then((res) => {
		return res.data;
	})
	.catch((err) => {
		console.log("The Api error", err);
		if (err.response.data.message && err.response.data.status_code) {
			console.log(err.response.data);
		}
		let { status } = err.response;
		if (status === 401) {
			console.log("Error", err.response.data);
			if (err.response.data.error_message === "Invalid token") {
				cookiesToDelete.forEach((record) => deleteCookie(record, "/"));
				// let route = getRedirectRoute();
				window.location.href = constants.BaseUrl+"login";
			}
			if (err.response.data.message) {
				return err.response.data;
			} else {
				return false;
			}
		} else if (status === 400) {
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
		} else {
			return false;
		}
	});
